import React, { useMemo } from 'react';
import { useTheme } from '../ThemeContext';
import useMediaQuery from '../hooks/useMediaQuery';


const categories = [

  {
    title: 'Discover TrustNest',
    description: 'Discover TrustNest fundamental concepts and explore our Cloud-based products designed by and for Thales engineers',
    url: 'https://thalesgroup.sharepoint.com/sites/TrustNest-Portal#explore-our-cloud-based-products-designed-by-and-for-thales-engineers'
  },
  {
    title: 'Begin your Cloud journey with TrustNest',
    description: 'Learn how to start your journey in the cloud with TrustNest and leverage its capabilities',
    url: 'getting-started'
  }

];

const styles = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#f7f8fb',
  
    fontFamily: '"Inter", "Segoe UI", sans-serif',
  },
  container: {
    maxWidth: 1100,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 40,
  },
  
  hero: {
    borderRadius: 36,
    padding: '48px 56px 56px',
    color: '#fff',
    background: 'linear-gradient(135deg, #729bcd 0%, #25286b 35%, #729bcd 100%)',
    boxShadow: '0 24px 60px rgba(69, 38, 144, 0.3)',
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
    alignItems: 'center',
    textAlign: 'center',
  },
  heroHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
  },
  heroHeading: {
    fontSize: '52px',
    fontWeight: 700,
    letterSpacing: '-0.02em',
    margin: 0,
    textAlign: 'center',
  },
  cardsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: 20,
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 20,
    padding: 24,
    boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    color: '#1f2933',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  },
  cardBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 44,
    height: 44,
    borderRadius: 14,
    fontWeight: 600,
    fontSize: 16,
    color: '#fff',
  },
  cardTitle: {
    fontSize: 18,
    fontWeight: 600,
    margin: 0,
  },
  cardDescription: {
    fontSize: 14,
    lineHeight: 1.5,
    margin: 0,
    color: '#4a5568',
  }
};
export default function HomePage() {
  const { darkMode } = useTheme();

  const isTablet = useMediaQuery('(max-width: 1023px)');
  const isMobile = useMediaQuery('(max-width: 640px)');
  const pageStyle = useMemo(() => ({
    ...styles.page,
    padding: isMobile ? '32px 16px 56px' : isTablet ? '48px 20px 72px' : styles.page.padding,
  }), [isMobile, isTablet]);
  const containerStyle = useMemo(() => ({
    ...styles.container,
    gap: isMobile ? 24 : styles.container.gap,
  }), [isMobile]);
  
  const heroStyle = useMemo(() => ({
    ...styles.hero,
    padding: isMobile ? '32px 24px 40px' : isTablet ? '40px 32px 48px' : styles.hero.padding,
    alignItems: isTablet ? 'flex-start' : 'center',
    textAlign: isTablet ? 'left' : 'center',
  }), [isMobile, isTablet]);
  const heroHeaderStyle = useMemo(() => ({
    ...styles.heroHeader,
    alignItems: isTablet ? 'flex-start' : 'center',
  }), [isTablet]);
  const heroHeadingStyle = useMemo(() => ({
    ...styles.heroHeading,
    fontSize: isMobile ? '34px' : isTablet ? '44px' : styles.heroHeading.fontSize,
    textAlign: isTablet ? 'left' : 'center',
  }), [isMobile, isTablet]);

  return (
    <div style={{ ...pageStyle, backgroundColor: darkMode ? '#121212' : '#f7f8fb', color: darkMode ? '#e0e0e0' : '#000' }}>
      <div style={containerStyle}>
        
        <header style={{ ...heroStyle, background: darkMode ? 'linear-gradient(135deg, #333 0%, #212121 35%, #333 100%)' : 'linear-gradient(135deg, #729bcd 0%, #25286b 35%, #729bcd 100%)' }}>
          <div>
            <div style={heroHeaderStyle}>
              <img src={darkMode ? 'trustnest-black.png' : 'favicon.ico'} alt="TrustNest Docs" style={{ height: 36 }} />
              
            </div>
            <h1 style={{ ...heroHeadingStyle, color: darkMode ? '#e0e0e0' : '#fff' }}>Find TrustNest answers fast</h1>
          </div>
           
        </header>

        <section style={styles.cardsGrid}>
          {categories.map(({ title, description, url }) => (
            <article
              key={title}
              style={{ ...styles.card, backgroundColor: darkMode ? '#333' : '#fff', color: darkMode ? '#e0e0e0' : '#1f2933', borderColor: darkMode ? '#424242' : '#e2e8f0', borderWidth: 1, borderStyle: 'solid' }}
              onClick={() => {
                if (url.startsWith('https')) {
                  window.open(url, '_blank');
                } else {
                  window.location.href = url;
                }
              }}              
              onMouseEnter={(event) => {
                event.currentTarget.style.transform = 'translateY(-4px)';
                event.currentTarget.style.boxShadow = darkMode ? '0 20px 35px rgba(224, 224, 224, 0.12)' : '0 20px 35px rgba(15, 23, 42, 0.12)';
              }}
              onMouseLeave={(event) => {
                event.currentTarget.style.transform = 'none';
                event.currentTarget.style.boxShadow = styles.card.boxShadow;
              }}
            >
              <span style={{ ...styles.cardBadge, backgroundColor: darkMode ?  '#333' : '#fff'}} aria-hidden="true">
                <img src={darkMode ? 'trustnest-black.png' : 'favicon.ico'} alt="logo" style={{ width: '80%', height: 'auto' }} />
              </span>
              <h2 style={{ ...styles.cardTitle, color: darkMode ? '#e0e0e0' : '#1f2933' }}>{title}</h2>
              <p style={{ ...styles.cardDescription, color: darkMode ? '#bdbdbd' : '#4a5568' }}>{description}</p>
            </article>
          ))}
        </section>
      </div>
    </div>
  );
}
